import { Card, Heading, Span } from "@icg360/design-system";

import { useEligibleCoverages } from "data/ss-data-hooks";

import { CoverageCard } from "./coverage-card";
import styles from "./extended-coverages.module.scss";
import { useCoverages } from "./hooks";

type CoverageName = "IDENTITY_FRAUD" | "MECHANICAL_BREAKDOWN" | "SERVICE_LINE";
type ExtendedCoveragesProps = {
  activeCoverages: {
    name: CoverageName;
    premium: string | null | undefined;
    active: boolean;
  }[];
};

const ExtendedCoverages = ({ activeCoverages }: ExtendedCoveragesProps) => {
  const { data, isLoading } = useEligibleCoverages();
  const coveragesToShow = useCoverages(data?.coverages);

  return !isLoading && (coveragesToShow?.length || activeCoverages?.length) ? (
    <Card>
      <Heading size="md" tag="h2" style={{ marginBottom: "8px" }}>
        Extended coverages
      </Heading>
      {coveragesToShow?.length ? (
        <div>
          <Span size="md" color="quiet">
            AVAILABLE
          </Span>
          <div className={styles.extendedCoverages}>
            <Card style={{ width: "100%" }} border>
              {coveragesToShow.map((coverage, i) => {
                const isLastItem = i === coveragesToShow.length - 1;
                return (
                  <CoverageCard
                    key={i}
                    coverage={coverage}
                    listOfCoverages={coveragesToShow}
                    isLastItem={isLastItem}
                  />
                );
              })}
            </Card>
          </div>
        </div>
      ) : null}
      {activeCoverages?.length ? (
        <div style={{ marginTop: "20px" }}>
          <Span size="md" color="quiet">
            ACTIVE
          </Span>
          <div className={styles.extendedCoverages}>
            <Card style={{ width: "100%", paddingBottom: 0 }} border>
              {activeCoverages.map((coverage, i) => {
                return (
                  <CoverageCard
                    key={i}
                    coverage={coverage}
                    listOfCoverages={[]}
                  />
                );
              })}
            </Card>
          </div>
        </div>
      ) : null}
    </Card>
  ) : null;
};

export default ExtendedCoverages;
